module.exports = __webpack_public_path__ + "assets/img/00028.2b12ce93.png";